import { Box, Container, Divider, Grid, Typography } from "@mui/material";
import Login from "../../components/login";
import Register from "../../components/register";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import useTranslation from "../../hooks/useTranslation";
import { useRouter } from "next/router";
import cssVars from '../../styles/vars.module.scss'
import { getClient } from "../../Providers/graphqlClient";
import { COUNTRIES } from "../../graphql/countries";
import CustomMetas from "../../components/custom-metas/customMetas";
import GuestEmailForm from "../../components/guest-email-form";
import { GET_AVAILABLE_STORE, GET_STORE_CONFIG } from "../../graphql/store/queries";

const AuthMain = ({ page, countries, stores, website_name = null }) => {

    const { t } = useTranslation()
    const router = useRouter()

    const handleOnChange = (event, newValue) => {
        if (newValue == 1) {
            router.push('/customer/login.html')
        } else {
            router.push('/customer/register.html')
        }
    }

    return (
        <Container maxWidth="xl" >
            <CustomMetas title={page === "login" ? "Login page" : "Register page"}
                description={page === "login" ? "Login page" : "Register page"}
                keywords={page === "login" ? "Login page" : "Register page"}
                url={process.env.NEXT_PUBLIC_STORE_FRONT + "/customer/" + (page === "login" ? "login.html" : "register.html")}
                page_type="product.item"
            />
            <Box
                sx={{
                    mt: "36px",
                    mb: { xs: 0, lg: 21 },
                    mx: "auto",
                    maxWidth: 430,
                    border: { sm: `1px solid ${cssVars.darkGray}` },
                    borderRadius: cssVars.radius,
                    width: { xs: 'unset', sm: 'fit-content' },
                    maxWidth: { xs: "calc(100vw - 24px)", lg: 430 },
                }}
            >
                <Tabs
                    onChange={handleOnChange}
                    aria-label="lab API tabs"
                    indicatorColor={cssVars.white}
                    sx={{
                        'button': {
                            width: "50%",
                            maxWidth: "unset",
                            fontSize: "16px !important",
                            fontWeight: "600 !important",
                            opacity: '1 !important',
                            backgroundColor: cssVars.extraLightGray,
                            padding: '30px 0'
                        }
                    }}
                >
                    <Tab
                        sx={{
                            borderTopLeftRadius: { md: cssVars.radius },
                            textTransform: "unset",
                            borderTopLeftRadius: `${cssVars.radius} !important`,
                            backgroundColor: page === "login" ? `${cssVars.white} !important` : "unset",
                            color: `${page === "login" ? cssVars.primary : cssVars.extraDarkGray} !important `
                        }}
                        label={t("Connection")}
                        value="1"
                    />

                    <Tab
                        sx={{
                            borderTopRightRadius: { md: cssVars.radius },
                            textTransform: "unset",
                            borderTopRightRadius: `${cssVars.radius} !important`,
                            backgroundColor: page === "register" ? `${cssVars.white} !important` : "unset",
                            color: `${page === "register" ? cssVars.primary : cssVars.extraDarkGray} !important `
                        }}
                        label={t("Create an access")}
                        value="2"
                    />
                </Tabs>
                {page === "login" ? <><Login website_name={website_name} /> <GuestEmailForm /></> : <Register countries={countries} stores={stores} />}
                <Divider sx={{ borderColor: cssVars.extraDarkGray, mx: 5 }} />
                <Grid sx={{ display: "flex", flexDirection: "column", p: 4, alignItems: "center", fontSize: 16 }}>
                    <Typography variant="p">
                        {t("For any questions")}
                    </Typography>
                    <Box sx={{ fontWeight: "bold" }} >021 624 00 54</Box>
                </Grid>
            </Box>
        </Container>
    )
}

export default AuthMain;

export const getStaticPaths = async ({ locales }) => {
    const pages = ["login.html", "register.html"]
    const paths = []
    locales.map(locale => pages.map(page => paths.push({ params: { slug: page }, locale: locale })))

    return {
        paths: paths,
        fallback: false
    }
}

export const getStaticProps = async ({ params, locale }) => {
    const client = getClient(locale)
    if (params.slug === 'login.html') {
        const { data: storeConfigData } = await client.query({ query: GET_STORE_CONFIG })
        return {
            props: {
                page: 'login',
                website_name: (storeConfigData.storeConfig.website_name || null)
            }
        }
    }
    else if (params.slug === 'register.html') {
        const { data: countries } = await client.query({ query: COUNTRIES })
        const { data: stores } = await client.query({ query: GET_AVAILABLE_STORE })
        return {
            props: {
                countries,
                stores,
                page: 'register'
            }
        }
    }
    else {
        return {
            notFound: true,
            revalidate: 10
        }
    }
}
